import { defaultTo } from 'ramda';
import { ICheckServiceMessageSchema } from '../../../repositories/billing-tariffs/entities/PublishTerms/CheckServiceMessageSchema';
import { IServicesUnavailableMessage } from '../../../types/reducers/checkoutInfo';

export function mapServicesUnavailableMessage(
  servicesUnavailableMessage?: ICheckServiceMessageSchema | null,
): IServicesUnavailableMessage | null {
  if (!servicesUnavailableMessage) {
    return null;
  }

  const { body, header } = servicesUnavailableMessage;

  return {
    body: defaultTo('', body),
    header: defaultTo('', header),
  };
}
